import { Link } from "react-router-dom";
import { ArrowUpRight, Home } from "lucide-react";
import Seo from "../components/Seo";
import BookingLink from "../components/BookingLink";
import { Reveal } from "../components/Reveal";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Directive Optive Solutions" description="That page doesn’t exist. Head back home, explore our services, or book a consultation." path="/404" noindex />
      <section className="relative flex min-h-[80vh] items-center bg-sage/85 pt-28" data-testid="notfound-section">
        <div className="container-shell relative z-10 max-w-2xl">
          <Reveal>
            <p className="eyebrow">404. Page not found</p>
            <h1 className="mt-5 text-balance font-serif text-5xl leading-[1.08] tracking-tight text-olive sm:text-6xl">This page doesn’t add up.</h1>
            <p className="mt-6 text-base leading-relaxed text-moss sm:text-lg">The link may be old or the address mistyped. Let’s get you somewhere useful.</p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Link to="/" data-testid="notfound-home-link" className="btn-outline"><Home className="h-4 w-4" /> Back to home</Link>
              <BookingLink page="404" dataTestId="notfound-book-button" className="btn-primary">Book a Consultation <ArrowUpRight className="h-4 w-4" /></BookingLink>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
